import { useCallback } from 'react';
import { useMessageListener } from './useMessageListener';
import { getWindowLocationLoadCompleteEvent } from '../../../../utils/window-listeners';
import { getEdgeCurrentLocation } from '../integration-utils';
/**
 * Runs a callback (defined by you) when a url is loaded containing the `urlPart` string.
 * (This helps us because the `window_location_load_complete` event currently does not return
 * the window location in its payload.)
 *
 * @param urlPart {string | RegExp} - location substring to check
 * @param cb {(location: string) => void | Promise<void>} - callback
 * @returns {void}
 */
var useLocationLoadCompleteCallback = function (urlPart, cb) {
    var finalCallback = useCallback(function (event) {
        var loadCompleteEndEvent = getWindowLocationLoadCompleteEvent(event);
        if (!loadCompleteEndEvent)
            return;
        void getEdgeCurrentLocation().then(function (location) {
            if (typeof urlPart === 'string') {
                if (!location.includes(urlPart))
                    return;
            }
            else if (!urlPart.test(location)) {
                return;
            }
            void cb(location);
        });
    }, [cb, urlPart]);
    useMessageListener(finalCallback);
};
export default useLocationLoadCompleteCallback;
